import React from "react";
import { useTranslation } from "react-i18next";

import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";
import themeColors from "../../../../ui/constants/themeColors";

export default function ProductionTodoDropdown({ loading, onRemove, setEdit }) {
	const { t } = useTranslation();

	const options = [
		{ text: t("edit", "Edit"), onClick: () => setEdit(true) },
		{
			text: t("remove", "Remove"),
			confirmText: t("removeTodoConfirmation", "Are you sure you want to remove this todo?"),
			onClick: onRemove,
		},
	];

	return (
		<div
			style={{
				position: "absolute",
				top: 0,
				bottom: 0,
				right: 0,
				borderLeft: `1px solid ${themeColors.GREY_FADED}`,
				width: 40,
			}}
		>
			<DropdownMenu
				options={options}
				loading={loading}
				menuStyle={{ top: 50, marginRight: 15 }}
				style={{
					width: "100%",
					height: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			/>
		</div>
	);
}
